
import React from 'react';

const HomeAbout = () => {
		return (
			<section className="home-about-panel ha-3col">
                <h2 className="vk-title hdiw-title">What can VizKidz do for me?</h2>
				<div className="genericUI-line"></div>
                <div className="ha-text-container">
                    <p className="hdiw-panel-para ha-para">Receive instant notifications if your child or loved one is spotted, and be reassured that any emergency medical or specific needs can be made instantly available to the persons at the scene.</p>
                    <p className="hdiw-panel-para ha-para">Our vizcodes can be scanned using most modern smartphones without downloading additional applications</p>
                    <p className="hdiw-panel-para ha-para">Our unique combination of fun, high visibility clothing and geolocation embedded id codes makes your loved ones easy to spot in a crowd, and easy to reunite in those terrifying situations when, despite our best efforts, they explore beyond our comfort zone.</p>
                </div>
            </section>
		);
}

export default HomeAbout;


// WEBPACK FOOTER //
// ./src/components/home/HomeAbout.js